<!-- 图书柜-我要买书-支付 -->
<template>
  <div class="BookcasePay">
    <div class="box" v-if="$route.params.order_id">
      <img class="payCode" :src="code_url" alt="">
      <p class="price">￥{{money}}</p>
      <CountDown class="hintText" beforeText="请在" afterText="s内使用微信付款"></CountDown>
    </div>
    <div class="successBox" v-else>
      <p class="text">订单已完成，感谢您的购买</p>
      <p class="bbtn-continue" @click="continueLook">继续查看商品</p>
    </div>

    <!-- mqtt  -->
    <Mqttws ref="mqttws" :topic="topic" @getMessage="getMessage"></Mqttws>
  </div>
</template>

<script>
  import CountDown from '@/components/Bookcase/Common/CountDown' // 倒计时
  import Mqttws from '@/components/Bookcase/Common/Mqttws'
  import { messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { checkData } from '../../../../static/js/utils/util'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  import { showToast } from '../../../../static/turnoverCabinet/js/utility'
  let vm, timer

  export default {
    name:'BookcasePay',
    components: {
      CountDown,
      Mqttws
    },
    computed: {
    },
    data() {
      return {
        topic: '/'+ config.serverPort2 + '/pay/' + config.deviceId + '/control/protocol', // 订阅用户是否支付订单


        code_url: '',
        money: ''
      }
    },
    created() {
      vm = this
      if (vm.$route.params.order_id) {
        // 初始化预警信息(买书未扫未支付1, 买书支付码未支付2)
        vm.$store.state.ECMall_warningData = {
          user_id: vm.$store.state.eUserInfo.user_id,
          type: 2,
          order_id: vm.$route.params.order_id
        }
      }
    },
    mounted () {
      console.log('this', this.$route)
      if (vm.$route.params.order_id) { vm.wxpay() }
    },
    destroyed () {
      console.log('vm.$store.state.ECMall_warningData', vm.$store.state.ECMall_warningData)
    },
    methods: {
      go(){
        vm.$router.go(-3)
      },
      // 继续查看
      continueLook () {
        let ECMall_pageSource = vm.$store.state.ECMall_pageSource
        vm.$store.state.ECMall_activeGoods = {}
        vm.$store.state.eUserInfo.ECMall_pageSource = ''
        vm.$router.go(-4)
        // vm.$router.replace('/Bookcase/' + ECMall_pageSource)
      },
      // 微信支付
      async wxpay () {
        let data = {
          order_sn: vm.$route.params.order_id,
          pay_amount: vm.$route.params.total_fee
          // user_id: "4A8BF3B6D97684C3366361A0D64E2F8F"
        }

        let res = await ECMallApi.wxpay(data)
        if (res.meta.code === 200) {
          vm.code_url = res.data.code_url
          vm.money = res.data.money
        } else {
          messageError(res.meta.messga)
        }
      },
      // 获取mqtt信息
      getMessage (res) {
        console.log('mqtt返回信息', res)
        // 支付成功
        if (res.meta.code === 200) {
          vm.$store.state.ECMall_warningData = {}
          vm.$router.push('/Bookcase/Pay')
        } else {
          messageError(res.meta.message)
        }
      }
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcasePay {
    width: 100%;
    height: 100%;
    padding: 0.52rem 0.42rem 0.62rem;
    display: flex;
    flex-direction: column;
    .box {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background-color: #ffffff;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      display: flex;
      flex-direction: column;
      align-items: center;
      .payCode {
        width: 3.35rem;
        margin-top: 2.67rem;
      }
      .price {
        margin: 0.58rem 0 0.37rem;
        font-size: 0.65rem;
        line-height: 1em;
        color: #e63c3c;
      }
      .text {
        font-size: 0.4rem;
        line-height: 1em;
        color: #666666;
      }
      .hintText {
        font-size: 0.4rem;
        line-height: 1em;
        color: #666;
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Buy/Pay.vue